import { AdminHeader, AdminSidebar } from 'components';
import ManagementDashboard from '../ManagementDashboard';

export const EmployeeSummaryDashboard = () => {
  return (
    <>
      <AdminHeader />
      <div className="dashboard-wrapper">
        <AdminSidebar />
        <ManagementDashboard />
      </div>
    </>
  );
};
